<template>
    <v-dialog v-model="dialog" width="960" persistent>
        <template #activator="{on}">
            <v-btn v-on="on" color="green" dark>Mark as built</v-btn>
        </template>
        <v-card v-if="model" :disabled="loading" :loading="loading">
            <v-card-title>
                Mark as Built
            </v-card-title>
            <v-card-text>
                <v-alert v-if="errors && errors.length" type="error">
                    <div v-for="error in errors" :key="error">{{ error }}</div>
                </v-alert>
                <v-row>
                    <v-col>
                        Update build value if necessary
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <v-card>
                            <v-card-title>Head</v-card-title>
                            <v-card-text>
                                <v-text-field
                                    v-if="model.headSetting != null"
                                    v-model="model.headSetting"
                                    label="Settings"
                                />
                                <v-text-field 
                                    v-if="model.headSetting2 != null"
                                    v-model="model.headSetting2"
                                    label="Settings 2"
                                />
                                <v-text-field 
                                    v-if="model.headLoft != null"
                                    v-model="model.headLoft"
                                    label="Loft"
                                />
                                <v-text-field 
                                    v-if="model.headLie != null"
                                    v-model="model.headLie"
                                    label="Lie"
                                />
                                <v-text-field 
                                    v-if="model.headStamp != null"
                                    v-model="model.headStamp"
                                    label="Stamping"
                                />
                                <v-text-field 
                                    v-if="model.headPaintfill != null"
                                    v-model="model.headPaintfill"
                                    label="Paintfill"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card>
                            <v-card-title>Shaft</v-card-title>
                            <v-card-text>
                                <v-text-field 
                                    v-if="model.shaftLength != null"
                                    v-model="model.shaftLength"
                                    label="Length"
                                />
                                <v-text-field 
                                    v-if="model.shaftCpm != null"
                                    v-model="model.shaftCpm"
                                    label="CPM"
                                />
                                <v-text-field 
                                    v-if="model.shaftSW != null"
                                    v-model="model.shaftSW"
                                    label="SW"
                                />
                                <v-text-field 
                                    v-if="model.shaftPaintfill != null"
                                    v-model="model.shaftPaintfill"
                                    label="Paintfill"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card>
                            <v-card-title>Grip</v-card-title>
                            <v-card-text>
                                <v-text-field 
                                    v-if="model.gripExtraWraps != null"
                                    v-model="model.gripExtraWraps"
                                    label="Extra Wraps"
                                />
                                <v-text-field 
                                    v-if="model.gripLogo != null"
                                    v-model="model.gripLogo"
                                    label="Logo"
                                />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-textarea
                            v-model="comment"
                            label="Your comment"
                            hint="Please leave a comment if necessary"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="cancel">Cancel</v-btn>
                <v-spacer />
                <v-btn
                    color="green"
                    @click="markAsBuilt"
                >Mark as Built</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from 'lodash'
export default {
    name: 'MarkClubAsBuilt',
    props: {
        club: {
            type: Object,
            required: true
        },
        handlingId : {
            type: Number,
            required: true
        }
    },
    data: () => ({
        loading: false,
        dialog:false,
        model: null,
        comment: null,
        errors: []
    }),
    watch: {
        // `mounted` ne rejoue pas quand Vue réutilise l'instance (liste patchée,
        // pagination du v-data-iterator). Le clone restait alors figé sur le club
        // du premier montage et le dialogue envoyait SON prescriptionRowId :
        // un autre club se retrouvait marqué "built".
        club: {
            handler (club) {
                this.model = _.cloneDeep(club)
            },
            immediate: true
        }
    },
    methods: {
        cancel () {
            this.model = _.cloneDeep(this.club)
            this.dialog = false
        },
        
        markAsBuilt() {
            this.loading = true;
            this.$store
                .dispatch("build/markAsBuilt", {
                    handlingId: this.handlingId,
                    // l'identifiant vient toujours du prop, jamais du clone éditable
                    id: this.club.prescriptionRowId,
                    model: this.model,
                    comment: this.comment,
                })
                .then((result) => {
                    if (result.success) {
                        this.cancel()
                        this.$emit("update");
                    }
                 })
                 .catch(({data}) => {
                    console.log(data)
                    this.errors = [];
                    for (const [key, value] of Object.entries(data.errors)) {
                        console.log(`${key}: ${value}`);
                        this.errors = this.errors.concat(value)
                    }
                 }) 
                .finally(() => (this.loading = false));
        },
    },
}
</script>